import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';

export default class XeditableDateField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'inline',
      refresh: undefined, // used to redraw the component
      value: this.props.value,
    }
  }

  componentDidMount = () => {
    setTimeout(() => this.renderEditable(), 500 );
  }

  componentWillReceiveProps = (nextProps) => {
    setTimeout(() => this.renderEditable(), 500 );
  }

  renderEditable = () => {
    $(`.${this.props.reference}`).editable({
        showbuttons : true,
        mode: 'inline',
        type:'date',
        format: 'MM-DD-YYYY',
        viewformat: 'MM-DD-YYYY',
        combodate: {
          minYear: (new Date()).getFullYear() - 2,
          maxYear: (new Date()).getFullYear() + 2,
        },
        success : function(response, newValue){
          let id = $(this).data('pk').split('-')[0];
          let field = $(this).data('pk').split('-')[1];
          let model= $(this).data('pk').split('-')[2];
          let app= $(this).data('pk').split('-')[3];
          let instance = {};
          instance[field] = newValue.format('YYYY-MM-DD');
          console.log('newValue');
          console.log(newValue.format('YYYY-MM-DD'));
          let cookie;
          let c_name = 'csrftoken';

          if(document.cookie.length > 0) {
              let c_start = document.cookie.indexOf(c_name + "=");
              if(c_start != -1) {
                  c_start = c_start + c_name.length + 1;
                  let c_end = document.cookie.indexOf(";", c_start);
                  if(c_end == -1) c_end = document.cookie.length;
                  cookie = unescape(document.cookie.substring(c_start,c_end));
              }
          } else {
              cookie = "";
          }

          $.ajax({
              url: '/api/xeditable/patch/' + app + '/' + model + '/' + id + '/',
              dataType: 'json',
              headers: {"X-CSRFToken": cookie},
              method: 'PUT',
              data: instance,
              success: (data) => {
                // console.log('Yay, we submitted a change.')
              }
          })
        },
    });
  }

  componentDidMount = () => {
    setTimeout(() => this.renderEditable(), 500 );
  }

  componentWillReceiveProps = (nextProps) => {
    setTimeout(() => this.renderEditable(), 500 );
  }

  render() {
    return (
      <a
        href='#'
        data-pk={`${this.props.reference}`}
        key={this.props.refresh}
        className={`${this.props.reference}`}
        data-type='combodate'
        data-format='MM-DD-YYYY'
        data-viewformat='MM-DD-YYYY'
        data-template='MM-DD-YYYY'
      >
        {this.props.display_value}
      </a>
    );
  }
}

XeditableDateField.propTypes = {
    value: PropTypes.node,
    reference: PropTypes.node,
    display_value: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/field/xeditable/xeditable_date_field.js